<div style="position: relative; width: 100%;">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
    style="position: absolute; top: -10px; right: 0px; width: 30px; cursor: pointer; z-index: 10;"
  />
  <div class="accordion-class">
    <h5>{{ data?.isEdit ? 'Edit Driver Route' : 'Create Driver Route' }}</h5>
    <mat-divider></mat-divider>
  </div>
</div>

<form class="admin-forms" [formGroup]="createDroForm">

  <div class="input-fileds-container">
    <div class="group driver-truck">
      <!-- Line 1: From and To Location -->
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>From Location:</mat-label>
            <input
              matInput
              type="text"
              #pickUpLocationSearchField
              formControlName="from_complete_address"
              required
            />
            <mat-error>Please Select From Location</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field>
            <mat-label>To Location:</mat-label>
            <input
              matInput
              type="text"
              #dropLocationSearchField
              formControlName="to_complete_address"
              required
            />
            <mat-error>Please Select To Location</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Line 2: Radius and Route Fare -->
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Radius (KM):</mat-label>
            <input
              matInput
              type="number"
              formControlName="driver_pin_radius"
              required
            />
            <mat-error>Please Enter Radius</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Route Fare (₹):</mat-label>
            <input
              matInput
              type="number"
              formControlName="price"
              required
            />
            <mat-error>Please Enter Route Fare</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Line 3: Date and Truck No -->
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Date:</mat-label>
            <input
              matInput
              [matDatepicker]="datePicker"
              formControlName="pickup_date"
              [min]="minDate"
              [max]="maxDate"
              (click)="datePicker.open()"
              readonly
              required
            />
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            <mat-error>Please Pick a Date</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Truck No:</mat-label>
            <mat-select
              formControlName="truck_selection"
              (selectionChange)="onTruckSelected($event.value)"
              placeholder="Select Truck"
              required
            >
              <mat-option *ngFor="let item of truckList" [value]="item">
                {{ item.displayText }}
              </mat-option>
            </mat-select>
            <mat-error>Please Select Truck</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Line 4: Driver Name, Truck Type, Truck Category -->
      <div class="row mtb">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Driver Name:</mat-label>
            <input
              matInput
              type="text"
              formControlName="driver_name"
              readonly
              style="pointer-events: none;" tabindex="-1"
            />
          </mat-form-field>
        </div>

        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Truck Category:</mat-label>
            <input
              matInput
              type="text"
              formControlName="truck_category"
              readonly
              style="pointer-events: none;" tabindex="-1"
            />
          </mat-form-field>
        </div>

        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Truck Type:</mat-label>
            <input
              matInput
              type="text"
              formControlName="truck_type"
              readonly
              style="pointer-events: none;" tabindex="-1"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <button
    type="submit"
    class="button buttonBlue"
    [class.spinner]="loading || submitting"
    [disabled]="loading || submitting"
    (click)="createDRO()"
  >
    {{ data?.isEdit ? 'Update' : 'Save' }}
  </button>
</form>
